import { render } from "./Resume.vue?vue&type=template&id=615db4a5&scoped=true"
import script from "./Resume.vue?vue&type=script&lang=js"
export * from "./Resume.vue?vue&type=script&lang=js"

import "./Resume.vue?vue&type=style&index=0&id=615db4a5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-615db4a5"]])

export default __exports__